/* tslint:disable:max-line-length */
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";

import * as model from "../model";
import { UserManager } from "oidc-client";
import { LoginTokenModel } from "../model";
import { from } from "rxjs/observable/from";
import { environment } from "../../../../environments/environment";

function validateRole(profile){
  if (profile["role"].includes('VendorUser') !== true)
    throw 'Account is not a registered Jean account'
}

@Injectable()
export class UserV2Service {
  public userManager: UserManager = null;

  constructor() {
    this.userManager = new UserManager({
      authority: environment.api.identityUrl,
      client_id: "alza_jean",
      redirect_uri: `${environment.appOrigin}/auth/signin-callback`,
      response_type: "id_token token",
      scope: "offline_access email profile openid alza",
      silent_redirect_uri: `${environment.appOrigin}/auth/signin-silent-callback`,
      prompt: "login"
    });
  }

  SigninRedirectCallback(url?: string): Observable<LoginTokenModel> {
    return from(
      this.userManager.signinRedirectCallback(url).then((user) => {
        validateRole(user.profile);
        return {
          access_token: user.access_token,
          expires_in: user.expires_in,
          token_type: user.token_type,
          refresh_token: user.refresh_token,
        };
      })
    );
  }

  Login(): Observable<void> {
    return from(
      this.userManager.signinRedirect({
        extraQueryParams: {
          culture: "cs-CZ",
          acr_values: "hideSociallogin",
        },
      })
    );
  }

  /**
   * Requests access token based on refresh token
   * http://undefinedundefined/swagger-ui.html#!/UserV2/RefreshToken
   */
  RefreshToken(): Observable<model.LoginTokenModel> {
    return from(
      this.userManager.signinSilent().then((user) => {
        validateRole(user.profile);
        return {
          access_token: user.access_token,
          expires_in: user.expires_in,
          token_type: user.token_type,
          refresh_token: user.refresh_token,
        };
      })
    );
  }

  /**
   * Logs out the user
   * http://undefinedundefined/swagger-ui.html#!/UserV2/Logout
   */
  Logout(): Observable<void> {
    return from(
      this.userManager.getUser().then((user) => {
        return this.userManager.signoutRedirect({
          id_token_hint: user.id_token,
          post_logout_redirect_uri: `${environment.appOrigin}/auth/logout`,
        });
      })
    );
  }

  SignInSilentCallback(url): Observable<LoginTokenModel> {
    return from(
      this.userManager.signinSilentCallback(url).then((user) => {
        if (user)
          validateRole(user.profile);
        return user
          ? {
              access_token: user.access_token,
              expires_in: user.expires_in,
              token_type: user.token_type,
              refresh_token: user.refresh_token,
            }
          : undefined;
      })
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/api/identity/services/user-v2.service.ts